import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Thumbnail from "src/components/thumbnail";

import { Media } from "src/types/media";
import { User } from "src/types/users";

import cx from "classnames";
import _ from "lodash";
import styles from "./enrollments.module.scss";
import Text from "src/components/text";


const defaultAssetImage = "/images/defaultIcons/default_asset.jpg";

const MostEnrolledReport: React.FC = () => {
  const { loading, learnings } = useSelector((state: any) => {
    const learningsState = _.get(
      state.coaching,
      "reports.teams.mostEnrolledLearnings",
    );
    const loading = _.get(learningsState, "loading");
    const learnings = _.get(learningsState, "items") || [];

    return {
      loading: loading,
      learnings: learnings,
    };
  }, _.isEqual);

  if(_.size(learnings) == 0 && !loading) {
    return <></>
  }

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h3>trending now: top enrolled courses</h3>
      </div>
      <div className={styles.grid}>
        {loading && (
          <>
            {_.times(5, (index) => (
              <PlaceholderEnrolledCard key={index} />
            ))}
          </>
        )}

        {!loading &&
          learnings.map((item, index) => (
            <div key={index} className={styles.wrapper}>
              <div className={styles.number}>{index + 1}</div>
              <EnrolledCard item={item} />
            </div>
          ))}
      </div>
    </section>
  );
};

interface EnrolledCardProps {
  item: any;
}

const EnrolledCard: React.FC<EnrolledCardProps> = ({ item }) => {
  const courseName = _.get(item.course, "name", "");
  const icon = _.get(item.course, "banner.background") as Media;
  const createdBy = _.get(item.course, "createdBy") as User;

  return (
    <div className={cx(styles.card)}>
      <div className={cx(styles.header)}>
        <div className={styles.icon}>
          <Thumbnail
            media={icon}
            defaultImage={defaultAssetImage}
            width={370}
          />
        </div>
      </div>

      <div className={styles.content}>
        <Text className={styles.name} text={item?.course?.name || ""} lines={1} />
        <div className={styles.metadatas}>
          <div className={styles.metadata}>
            <span className={styles.label}>{_.capitalize(item?.type) || "Course"}</span>
          </div>  
          <div className={styles.border} />
          <div className={styles.metadata}>
            <i className="paperflite-assessment"></i>
            <span className={styles.label}>{`${item?.enrolled || 0} users enrolled`}</span>
          </div>  
          <div className={styles.border} />
          <div className={styles.metadata}>
            <span className={styles.label}>{`created by ${createdBy?.firstName}`}</span>
          </div>  
        </div>
      </div>
    </div>
  );
};

const PlaceholderEnrolledCard: React.FC<object> = () => {
  return (
    <div
      className={cx(styles.card, styles.cardplaceholder, styles.placeholder)}
    >
      <div className={cx(styles.header)}>
        <div className={cx(styles.icon, styles.block)}> </div>
      </div>

      <span className={cx(styles.contentplaceholder, styles.block)}> </span>

      <div className={cx(styles.metadata)}>
        <span className={cx(styles.one, styles.block)} />
        <span className={styles.border} />
        <span className={cx(styles.two, styles.block)} />

        <span className={styles.border} />
        <span className={cx(styles.three, styles.block)} />
      </div>
    </div>
  );
};

export default MostEnrolledReport;